/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  selectCompanyCode,
  selectReservationCode,
  getGuestByReservation,
  getReservationByReference,
  setReservationData,
} from '../store/widgetSlice';

import {
  setMessage,
} from '../store/authSlice';

import Widget from '../components/common/Widget';

export default function WidgetView() {
  const { reference } = useParams();
  const dispatch = useDispatch();
  const companyCode = useSelector(selectCompanyCode);
  const reservationCode = useSelector(selectReservationCode);

  useEffect(() => {
    const fetchReservation = async () => {
      if (reference) {
        try {
          const reservation = await dispatch(getReservationByReference({ reference })).unwrap();

          if (reservation) {
            dispatch(setReservationData({
              companyCode: reservation.companyCode,
              reservationCode: reservation.reservationCode,
            }));
          }
        } catch (confirmationIdError) {
          dispatch(setMessage({ message: 'Guest information could not be retrieved', severity: 'error' }));
        }
      }
    };

    fetchReservation();
  }, [dispatch, reference]);

  useEffect(() => {
    const fetchGuest = async () => {
      if (companyCode && reservationCode) {
        try {
          const guest = await dispatch(getGuestByReservation({ companyCode, reservationCode })).unwrap();

          if (guest) {
            dispatch(setMessage({ message: 'Guest information retrieved', severity: 'success' }));
          }
        } catch (confirmationIdError) {
          dispatch(setMessage({ message: 'Guest information could not be retrieved', severity: 'error' }));
        }
      }
    };

    fetchGuest();
  }, [dispatch, companyCode, reservationCode]);

  return (
    <>
      <Widget />
    </>
  );
}
